<template>
  <v-container grid-list-md fluid>
    <v-layout align-center justify-center column>

      <v-flex x12>
        <v-layout align-center justify-center>
          <img src="https://scai.ingana.com.co/img/convenios/logo_20180413_093840.png" style="width: 120px">
        </v-layout>
      </v-flex>

      <v-flex>
        <v-layout align-center ajustify-center>
          <h1 class="pa-0">LICEO FESAN</h1>
        </v-layout>
      </v-flex>

      <v-flex>
        <v-layout align-center ajustify-center>
          <h3 class="pa-0">Impresión de Formularios</h3>
        </v-layout>
      </v-flex>

      <v-flex>
        <v-layout align-center ajustify-center class="text-xs-center">
          <span class="subheading pt-5">Su número de radicado es <b>{{ codigo }}</b>, conservelo en caso de modificaciones o re-impresión de los formularios</span>
        </v-layout>
      </v-flex>

      <v-flex x12 sm8 md4>
        <v-card class="elevation-12 mt-1">

          <v-card-text>

            <v-layout align-center justify-center column>

              <v-btn color="primary" @click="imprimirFormularioInscripcion"
                     target="blank">Formulario Inscripcion
              </v-btn>
              <v-btn color="primary" href="https://scai.ingana.com.co/centro_documentos/estaticos/FORMATO_DE_PROCEDENCIA_ACADEMICA.pdf"
                     target="blank">Procedencia Académica
              </v-btn>
              <v-btn color="primary" href="https://scai.ingana.com.co/centro_documentos/estaticos/FORMULARIO_DE_ENTREVISTA_2020.pdf" target="blank">
                Formulario Entrevista
              </v-btn>
              <!--v-btn color="primary" @click="modificarSolicitud">Modificar Solictud</v-btn-->
            </v-layout>

          </v-card-text>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import Api from '../service/api'

  export default {
    name: "Impresiones",
    data() {
      return {
        codigo: '',
      }
    },
    mounted() {
      this.codigo = this.$route.params.codigo

    },
    methods: {
      imprimirFormularioInscripcion() {
        this.$router.push({
          name: 'FormularioInscripcion',
          params: {
            codigo: this.codigo,
          }
        })
      },

    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Impresiones.vue